<template>
  <v-app id="inspire" :class="!$route.meta.noSidebar ? 'wrapper' : 'register-container'">
    <v-app-bar
      app
      elevate-on-scroll
      elevation="0"
      :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
      class="custom-navbar"
      v-if="!$route.meta.noSidebar"
    >
      <v-container class="fill-height app-bar-container">
        <v-app-bar-nav-icon
          class="d-md-none d-sm-flex d-xl-none d-lg-none"
          @click="drawer = !drawer"
        ></v-app-bar-nav-icon>

        <DashboardView></DashboardView>

        <v-spacer></v-spacer>

        <!-- <SignalsView></SignalsView> -->

        <!-- <LanguageMenu></LanguageMenu> -->

        <SwitcherView></SwitcherView>

        <NotificationView></NotificationView>

        <LogoutView></LogoutView>
        <audio
          id="notification-bell"
          src="sounds/notification-bell.wav"
          preload="auto"
        ></audio>
      </v-container>
    </v-app-bar>
    <div
      :class="!$route.meta.noSidebar ? 'custom-container' : 'register-container-fluid'"
    >
      <v-row no-gutters>
        <v-col
          xl="2"
          class="custom-width-navigation-drawer"
          v-if="!$route.meta.noSidebar"
        >
          <div class="navigation-drawer-container">
            <v-navigation-drawer
              v-model="drawer"
              :permanent="$vuetify.breakpoint.mdAndUp"
              width="240"
              class="navigation-drawer sidebar-navigation-drawer"
              :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
            >
              <AdminLogo></AdminLogo>
              <AllMenu></AllMenu>
            </v-navigation-drawer>
            <HelpAssistantWidget />
          </div>
        </v-col>
        <v-col
          class="custom-width-main registration-page"
          style="overflow-y: scroll; height: 100vh"
        >
          <v-main>
            <router-view></router-view>
          </v-main>
        </v-col>
      </v-row>
    </div>
  </v-app>
</template>

<script>
import AdminLogo from "./components/TopBarAndSideBar/AdminLogo.vue";
import AllMenu from "./components/TopBarAndSideBar/AllMenu.vue";
import DashboardView from "./components/TopBarAndSideBar/DashboardView.vue";
// import LanguageMenu from "./components/TopBarAndSideBar/LanguageMenu.vue";
import LogoutView from "./components/TopBarAndSideBar/LogoutView.vue";
import NotificationView from "./components/TopBarAndSideBar/NotificationView.vue";
// import SignalsView from "./components/TopBarAndSideBar/SignalsView.vue";
import { ADMINS__ACTIONS, AUTHENTICATION__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import SwitcherView from "./components/TopBarAndSideBar/SwitcherView.vue";
import { startSessionMonitor, stopSessionMonitor } from "./utils/sessionMonitor";
import HelpAssistantWidget from "./components/assistant/HelpAssistantWidget.vue";

export default {
  data() {
    return {
      drawer: false,
      isInitializing: true,
    };
  },
  components: {
    // LanguageMenu,
    NotificationView,
    // SignalsView,
    SwitcherView,
    DashboardView,
    LogoutView,
    AdminLogo,
    AllMenu,
    HelpAssistantWidget,
  },
  computed: {
    ...mapState("admins", ["loggedAdmin"]),

    showLogin() {
      return this.$route.name === "login";
    },

    showCreateAccount() {
      return this.$route.name === "CreateAccount";
    },

    showRegistration() {
      return this.$route.name === "RegistrationView";
    },

    showSendOtp() {
      return this.$route.name === "SendOtp";
    },
  },

  methods: {
    ...mapActions("admins", [ADMINS__ACTIONS.GETADMIN]),

    ...mapActions("authentication", [AUTHENTICATION__ACTIONS.INITIALIZE_AUTH]),

    async initializeApplication() {
      try {
        const isAuthenticated = await this.$store.dispatch(
          "authentication/INITIALIZE_AUTH"
        );

        if (isAuthenticated) {
          startSessionMonitor();
        } else if (!this.$route.meta.noAuth && this.$route.path !== "/") {
          this.$router.push("/");
        }
      } catch (error) {
        console.error("Error initializing application:", error);
      } finally {
        this.isInitializing = false;
      }
    },
  },

  async created() {
    const hasToken = !!localStorage.getItem("token");

    if (hasToken && !this.loggedAdmin) {
      try {
        await this[ADMINS__ACTIONS.GETADMIN]();
      } catch (error) {
        console.error("Error fetching admin data:", error);
        if (error.response && error.response.status === 401) {
          await this.$store.dispatch("authentication/LOGOUT");
          this.$router.push("/");
        }
      }
    }

    await this.initializeApplication();
  },

  beforeDestroy() {
    stopSessionMonitor();
  },

  watch: {
    "$store.state.authentication.token"(newVal) {
      if (newVal && !this.isInitializing) {
        startSessionMonitor();
      } else if (!newVal && !this.isInitializing) {
        stopSessionMonitor();
      }
    },

    $route(to) {
      if (!to.meta.noAuth && to.path !== "/" && !this.$store.state.authentication.token) {
        this.$router.push("/");
      }
    },

    loggedAdmin: {
      handler(val) {
        if (val && val.theme_preference !== undefined) {
          this.$vuetify.theme.dark = val.theme_preference === 1;
        }
      },
      immediate: true,
    },
  },
};
</script>
